<template>
  <v-autocomplete
    :class="{ required: field.required }"
    :model-value="field.value"
    :rules="validationRules"
    :items="field.dropDownValues"
    v-bind="{ ...$props, ...$attrs }"
    @update:model-value="value => $emit('input', value || '')"
    density="compact"
    clearable
    hide-details="auto"
    :placeholder="field.label"
    :persistent-placeholder="persistentPlaceholder ? Boolean(field.placeholder) : false"
    open-on-clear>
    <template #label v-if="displayLabel">
      {{ t('customFields.forms.customFieldsForm.placeholders.chooseAnOption') }}
    </template>
  </v-autocomplete>
</template>

<script>
import customFieldTypeMixin from '@/modules/custom_fields/mixins/customFieldTypeMixin';
import { t } from '@nova/core';

export default {
  name: 'custom-field-dropdown',
  mixins: [customFieldTypeMixin],
  methods: { t }
};
</script>
